import { Component, EventEmitter, Output, input, signal, effect } from '@angular/core';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';

@Component({
  selector: 'app-kiosk-pager-atom',
  templateUrl: './kiosk-pager-atom.component.html',
  standalone: false,
})
export class KioskPagerAtomComponent {
  readonly color = input<IContentBuilderFieldColor>();
  readonly value = input.required<string>();
  readonly pagerSize = input.required<number>();

  @Output() valueEmitter = new EventEmitter<string | boolean>();

  pagerValue = signal(''); // use linkedSignal once available to avoid the effect

  constructor() {
    effect(
      () => {
        if (this.value()) {
          this.pagerValue.set(this.value());
        }
      },
      {
        allowSignalWrites: true,
      },
    );
  }

  onNumberClick(value: number | string): void {
    const valueStr = value.toString();
    this.pagerValue.set(this.pagerValue() + valueStr);
    this.onInputChange();
  }

  onDeleteClick(): void {
    this.pagerValue.set('');
    this.emitValue();
  }

  onInputChange(): void {
    // Emit value as soon as at least one character is entered
    if (this.pagerValue().length > 0) {
      this.emitValue();
    }
  }

  emitValue(): void {
    this.valueEmitter.emit(this.pagerValue());
  }
}
